import React from "react"
import {colors} from "@indebted/theme"
import {Box, Card, Typography} from "@material-ui/core"

import {LargeTooltip} from "./LargeTooltip"

function Metric({color, title, description, tooltip}) {
	return (
		<Box mb={3}>
			<Card style={{borderLeft: `4px solid ${colors[color]}`}}>
				<Box p={4}>
					<LargeTooltip title={tooltip || ""} placement="top">
						<Typography variant="h4">{title}</Typography>
					</LargeTooltip>
					{description}
				</Box>
			</Card>
		</Box>
	)
}

export {Metric}
